import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../services/config';
import { TransportPlannerProfileModel } from '../models';
import { TransportPlannerProfileEndpoint } from '../constants/transport-planner-profile-endpoint';

@Injectable({
  providedIn: 'root',
})
export class TransportPlannerProfileItemService {
  constructor(private http: WrapperHttpService) {}

  getTransportPlannerProfile(id: number): Observable<TransportPlannerProfileModel> {
    const url = `${API_URL}${TransportPlannerProfileEndpoint.Base}${TransportPlannerProfileEndpoint.Profiles}/${id}`;
    return this.http.withLoading().get<TransportPlannerProfileModel>(url);
  }

  createTransportPlannerProfile(body: TransportPlannerProfileModel): Observable<TransportPlannerProfileModel> {
    const url = `${API_URL}${TransportPlannerProfileEndpoint.Base}${TransportPlannerProfileEndpoint.Profiles}`;
    return this.http.withLoading().post<TransportPlannerProfileModel>(url, body);
  }

  updateTransportPlannerProfile(body: TransportPlannerProfileModel): Observable<TransportPlannerProfileModel> {
    const url = `${API_URL}${TransportPlannerProfileEndpoint.Base}${TransportPlannerProfileEndpoint.Profiles}`;
    return this.http.withLoading().post<TransportPlannerProfileModel>(url, body);
  }
}
